import { MDBCard, MDBCardBody, MDBCardHeader, MDBCol, MDBRow ,MDBIcon , MDBFooter , MDBBtn} from 'mdbreact';
import React, { Component } from 'react'



export class ViewNewsAndUpdate extends Component {
    constructor() {
        super();
        this.state = {
            back: false,

        }
    }

    componentDidMount() {
        // console.log(this.props);
    }

    capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }
    render() {
        return (
            <div>
                <h4><b>News and Updates</b></h4>
                <MDBCard style={{ boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0", paddingBottom: "5%", height: "max-content", overflow: "auto" }}>

                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol>
                            <h6 className="font-weight-bold">{this.props.viewNewsObj["news_title"]}</h6>

                             <p>To : {this.props.viewNewsObj["user_types"].map((type) => (
                                 <span className="badge badge-light badge-pill shadow-none mr-2 font-weight-normal p-2">
                                     {this.capitalize(type.replace(/_/g, " "))}
                                 </span>
                             ))}
                             </p>
                             <p  className="mb-0 text-muted">
                                 <MDBIcon className="mr-2 ml-2" icon="user-alt" />
                                {this.props.viewNewsObj["sent_by_user_name"]} <span className="mr-2 ml-2" >|</span>

                             {new Date(this.props.viewNewsObj["sent_on"]).toDateString()} <span className="" >,</span>  {new Date(this.props.viewNewsObj["sent_on"]).toTimeString()} </p>
                            </MDBCol>
                        </MDBRow>
                        <hr />
                        <MDBRow>
                            <MDBCol>
                                <h5 style={{ color: "gray" }}>Hello {this.props.viewNewsObj["sent_by_user_name"]}!</h5>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow >
                            <MDBCol>
                            <p className="description">{this.props.viewNewsObj["news_message"]}</p>
                            </MDBCol>
                        </MDBRow>
                    </MDBCardBody>
                </MDBCard>
                <MDBRow>
                    <MDBCol size="12" md="12" sm="12">
                        <MDBCard>
                            <MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)", zIndex: "1" }} color="white" className="pb-1 pt-1 text-right">
                                <MDBRow className="text-right">
                                    <MDBCol size="12" md="6" sm="6"></MDBCol>
                                    <MDBCol size="12" md="6" sm="6">

                                        <MDBBtn color="none" style={{ background: "black", color: 'white', fontSize: 'calc(8px + .5rem)', textTransform: 'none', width: "12rem" }} onClick={() => window.location.reload()} >Back</MDBBtn>
                                    </MDBCol>
                                </MDBRow>

                            </MDBFooter>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
            </div>
            
        )
    }
}

export default ViewNewsAndUpdate
